import React from "react";

const Terms = () => {
   return(<h1>This is Terms</h1>);
};
export default Terms;